<!-- 协会查看考生详情页面 -->
<template>
  <div id="app">
    <!-- <div id="top">
      <span class="rightcha"
        ><img width="20px" src="../../assets/cha.png" />
        <span class="centerwz">预约考试</span></span
      >
    </div> -->
    <div class="yuinfo">预约科目</div>
    <div class="own_contain">
      <!-- <input class="own_input" v-model="ownnameinput" placeholder="姓名*"> -->
      <div class="own_type">预约考试等级</div>
      <br />
      <div class="input"><van-cell-group>
  <van-field v-model="studentDetails.examRank" size="large"  />
</van-cell-group></div>
<br>
    
      <van-checkbox-group v-model="studentDetails.subject">
        <van-checkbox name="理论"> 理论 </van-checkbox>
        <br />
        <van-checkbox name="实操">实操 </van-checkbox>
        <br />
        <!-- <van-checkbox name="综合评审">综合评审 </van-checkbox> -->
      </van-checkbox-group>

    </div>
    <br />
    <div class="yuinfo">预约时间 </div>
    <div class="own_contain">
      <!-- <input class="own_input" v-model="ownnameinput" placeholder="姓名*"> -->
      <div class="own_name">预约考试地点</div>
      <br>
      <div class="input"><van-cell-group>
      <van-field v-model="studentDetails.examAddress" size="large"  placeholder="预约考试地点" />
    </van-cell-group></div>
      <!-- <input type="text" id="examName" v-model="studentDetails.examAddress" /> -->
      <br />
      <div class="own_name">预约考试时间</div><br>
      <div class="input"><van-cell-group>
      <van-field v-model="studentDetails.examTime" size="large"  placeholder="预约考试时间" />
    </van-cell-group></div>
      <!-- <input type="text" id="examName" v-model="studentDetails.examTime" /> -->
    </div>
    <br />
    <div class="yuinfo">预约信息</div>
    <div class="own_contain">
      <div class="own_name">姓名</div><br>
      <div class="input"><van-cell-group>
      <van-field id="examName" v-model="studentDetails.examName" size="large"  placeholder="用户名" />
    </van-cell-group></div>
      <!-- <input type="text" id="examName" v-model="studentDetails.examName" /> -->
      <!-- <input class="own_input" v-model="ownnameinput" placeholder="姓名*"> -->
      <div class="own_type">证件类型</div><br>
      <div class="input"><van-cell-group>
      <van-field id="examName" v-model="studentDetails.examCardStatus" size="large"  placeholder="证件类型" />
    </van-cell-group></div>
      <!-- <van-checkbox-group v-model="studentDetails.examCardStatus">
        <van-checkbox name="身份证">身份证</van-checkbox>
        <br />
        <van-checkbox name="护照">护照</van-checkbox>
        <br />
        <van-checkbox name="其他">其他</van-checkbox>
      </van-checkbox-group> -->
      <div class="own_typtel">证件号码</div><br>
      <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examCard" size="large"  placeholder="证件号码" />
    </van-cell-group></div>
      <!-- <input type="text" id="examCard" v-model="studentDetails.examCard" /> -->
      <!-- <input class="own_typetel_input" v-model="owndentifyinput" placeholder="填写证件号码"> -->
      <div class="own_sex">性别</div>
        <br />
      <van-checkbox-group shape="square" direction="horizontal" v-model="studentDetails.examSex">
        <van-checkbox name="男">男</van-checkbox>
        <van-checkbox name="女">女</van-checkbox>
      </van-checkbox-group>
      <div class="own_telnum">手机号</div><br>
      <!-- <input-box v-model="owntelinput" placeholder="请输入手机号码">
    </input-box> -->
    <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examPhone" size="large"  placeholder="手机号码" />
    </van-cell-group></div>

      <!-- <input type="text" id="examPhone" v-model="studentDetails.examPhone" /> -->
      <br />
      <br />
    </div>

    <div class="yuinfo">预约条件</div>

    <div class="own_contain">
      <div class="own_name">最高学历</div>
      <!-- <div class="select_container" @click="selectclick">
	<span class="select_l">
          最高学历
</span><van-icon class="select_r" name="arrow-down" />
</div> -->
        <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examRecord" size="large"  placeholder="请输入最高学历" />
    </van-cell-group></div>
      <!-- <input type="text" id="examCard" v-model="studentDetails.examRecord" /> -->
      
      <div class="own_name">证书获取时间</div>
        <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examGetTime" size="large"  placeholder="请输入获取证书时间" />
    </van-cell-group></div>
      <!-- <input type="text" id="examCard" v-model="studentDetails.examGetTime" /> -->
      <!-- <div class="select_container" @click="select2click">
	<span class="select_l">
          2003年6月35日
</span><van-icon class="select_r" name="arrow-down" />
</div> -->
      <div class="own_name">专业名称</div>
      <!-- <div class="select_container" @click="select3click">
	<span class="select_l">
          其他
</span><van-icon class="select_r" name="arrow-down" />
</div> -->
      <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examCareer" size="large"  placeholder="请输入专业名称" />
    </van-cell-group></div>
      <!-- <input type="text" id="examCard" v-model="studentDetails.examCareer" /> -->
      <!-- <div class="filetext">上传毕业证书扫描件</div>
<div class="filetext2">（PDF格式：小于1M）</div>

<div class="fileboxheader">
	毕业证书扫描件
</div>
<div   class="fileboxmain">
	<div class="fileboxbox">
		<img src="../../assets/cha.png" alt="">
		<div class="fileboxtext">点击/拖拽上传</div>
	</div>

</div> -->
     <div class="own_name">毕业证书</div>
      <file-box @bindup='boxidentenfyfile' headert="毕业证书" :mainup='boxidentenfypdf'></file-box>

      <div class="own_name">社保记录</div>
      <file-box @bindup='socialfile' headert="社保记录" :mainup='socialpdf'></file-box>
      <div class="own_name">工作证明</div>
      <file-box @bindup='socialfile' headert="工作证明" :mainup='socialpdf'></file-box>

      <div class="own_name">身份证(正反面)</div>
      <file-box @bindup='cardfile' headert="身份证（正反面）" :mainup='cardpdf'></file-box>

      <div class="own_name">本人证件照</div>
      <file-box @bindup='photofile' headert="本人证件照" :mainup='photopdf'></file-box>
      <!-- <div class="filetext">上传毕业证书扫描件</div>
<div class="filetext2">（PDF格式：小于1M）</div>

<div class="fileboxheader">
	毕业证书扫描件
</div>
<div   class="fileboxmain">
	<div class="fileboxbox">
		<img src="../../assets/cha.png" alt="">
		<div class="fileboxtext">点击/拖拽上传</div>
	</div>

</div> -->

      <!--
<div class="filetext">上传毕业证书扫描件</div>
<div class="filetext2">（PDF格式：小于1M）</div>

<div class="fileboxheader">
	毕业证书扫描件
</div>
<div   class="fileboxmain">
	<div class="fileboxbox">
		<img src="../../assets/cha.png" alt="">
		<div class="fileboxtext">点击/拖拽上传</div>
	</div>

</div> -->

      <!-- <div class="filetext">上传毕业证书扫描件</div>
<div class="filetext2">（PDF格式：小于1M）</div>

<div class="fileboxheader">
	毕业证书扫描件
</div>
<div   class="fileboxmain">
	<div class="fileboxbox">
		<img src="../../assets/cha.png" alt="">
		<div class="fileboxtext">点击/拖拽上传</div>
	</div>

</div> -->

      <div class="own_name">证书邮件地址</div>
      <!-- <input class="own_input" v-model="ownnameinput" placeholder="请输入邮寄地址*"> -->
      <!-- <choose-box :rtest='ownnameinput' :showicon="true" class="select_container"
        v-model="studentDetails.examCertificate">

      </choose-box> -->
      <div class="input"><van-cell-group>
      <van-field id="examCard" v-model="studentDetails.examCertificate" size="large"  placeholder="邮寄地址" />
    </van-cell-group></div>
    </div>
      <van-divider :style="{ padding: '0 ',margin:0 }" />
    <div class="own_contain">
<van-row type="flex" justify="space-around" gutter="31">
  <van-col span="12"><van-button size="large" plain type="info" v-if="status=='toTest' && paystatus=='paid'" @click="submitreject(studentDetails.id)">驳回</van-button></van-col>
  <van-dialog
    v-model="show"
    title="驳回原因"
    show-cancel-button
    :beforeClose="uploadfilemoreinfo"
    confirmButtonColor="#54B0FB"
    confirmButtonText="确定"
  >
<!--驳回输入框-->
    <van-field
      v-model="message"
      rows="5"
      autosize
      type="textarea"
      placeholder="请输入文字"
      background="#F5F5F5"
      maxlength="200"
      show-word-limit
    />
  </van-dialog>
  <van-col span="12"><van-button size="large" type="info" v-if="status=='toTest' && paystatus=='paid' " @click="upstatus(studentDetails.id,studentDetails.examName)">通过</van-button></van-col>
</van-row>


    </div>

  </div>
</template>

<script>
import ArticleItem from '@/components/article-item/index.vue'
import inputBox from '@/components/input.vue'
import fileBox from '@/components/filebox.vue'
import chooseBox from '@/components/choose.vue'
import { uploadfilemoreinfo } from '../../api/apitotal.js'
import { Dialog } from 'vant';
// Dialog({ message: '提示' });
export default {
  name: 'App',
  components: {
    ArticleItem,
    fileBox,
    inputBox,
    chooseBox
  },
  data() {
    return {
      radio: '1',
      studentDetails:{},
      active: 1,
      sexcheck: true,
      typecheck: true,
      phonecheck: false,
      othercheck: false,
      ownnameinput: "",
      owndentifyinput: "",
      owntelinput: "",
      owntestinput: "",
      photopdf: '',
      cardpdf: '',
      socialpdf: '',
      boxidentenfypdf: '',
      studentnamepdf: '',
      Reject:'',
      show:false,
      message:''

    }
  },
  created() {
    this.fetchDetails();
    // this.getword();
  },
  methods: {
    fetchDetails: function () {
      // console.log(this.$http)
      id:this.$route.params.phone
      this.$http.get(`/association/getDetails/${this.$route.params.phone}`).then(res => {
        if (res.data.success) {
          console.log(res.data.data)
          this.studentDetails = res.data.data
        } else {
          console.log(err)
        }

      }).catch(err => console.log(err))
    },
    // submitreject(id) {
    //   this.showdailog = false;
    //   var Reject = '111';
    //   uploadfilemoreinfo(
    //     `association/updateReject`,
    //     `examId=${id}&Reject=${Reject}`,
    //     "post"
    //   ).then((res) => {
    //     if (res.data.success && res.status == 200) {
    //       alert("驳回原因：");
    //        this.$router.push({ path: `/namesign` })
    //     }
    //   });
    // },
    
    // 驳回
    submitreject(id){
    
       this.show = true;
    },
    uploadfilemoreinfo(action, done){
      if (action === 'cancel') {//取消按钮
        done();
      } else if (action === 'confirm') {//确定按钮
          //向后端传值并关闭dialog弹出框
            this.show = false;
          };
        this.message='';
        done()
    },


    // upstatus(id) {
    //   console.log(id);
    //   uploadfilemoreinfo(
    //     `association/updateAssociation`,
    //     `examId=${id}`,
    //     "post"
    //   ).then((res) => {
    //     if (res.data.success && res.status == 200) {
    //       alert("确认要通过***的信息吗？");
    //       this.$router.push({ path: `/namesign` })
    //     }
    //   });
    // },

    // 通过按钮
    upstatus(id,examName){
      console.log(id)
      console.log(examName)
      Dialog.confirm({
        
        confirmButtonText:'确定',
        confirmButtonColor:'#54B0FB',
        title: '提示',
        message: '确认要通过'+examName +'的报考信息吗？',
      })
        .then(() => {
          // on confirm
          console.log(123)
           this.$router.push({ path: `/namesign` })

        })
        .catch(() => {
          // on cancel
        });

    },
    sendcode() {

    },
    boychang(value) {
      this.sexcheck = true
    },
    girtchang(value) {
      this.sexcheck = false
    },
    otherCcheck() {
      this.othercheck = true
      this.phonecheck = false
      this.typecheck = false


    },
    phoneCcheck() {
      this.othercheck = false
      this.phonecheck = true
      this.typecheck = false
    },
    typeCcheck() {
      this.othercheck = false
      this.phonecheck = false
      this.typecheck = true
    },

    owninfonext() {
      var logdata = {
        "examSex": this.sexcheck ? '男' : '女',
        "examCard": this.owndentifyinput,
        "examName": this.ownnameinput,
        "examPhone": this.owntelinput,

      }
      dateadrees(`ExamOrder/addExamOrder?Id=${localStorage.getItem('ID') || null}`, logdata, 'post').then(res => {

      })
      this.$router.push('/upload_filesC')

    }
  },
}
</script>

<style lang='less' scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;

  width: 100%;
  height: 100vh;
}
.input{
  width: 690px;
height: 90px;
border-radius: 10px;
border: 1px solid #DCDCDC;
  
}

.cat-input {
  width: 100%;
  height: @minboxgao;

  margin-top: @padingboxmax;
  line-height: @minboxgao;
}

.own_contain {
  width: 100%;
  background: white;
  padding: 20px;
  box-sizing: border-box;
}

.yuinfo {
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @backgroundcolor;
  font-size: 32px;
  font-weight: 600;
}

.own_test_out {
  position: relative;
}

.gettest {
  position: absolute;
  right: 5px;
}

.own_typee {

  margin-left: @checkleft;
}

.own_sexs {

  margin-left: @checkleft;
}

.own_type,
.own_contain #identify,
.own_contain #identphone,
.own_contain #other,
.own_contain #girt,
.own_contain #boy,
.own_typtel,
.own_sex,
.own_telnum,
.own_test {
  margin-top: @padingbox;
  margin-right: @checkringht;
}

.own_next {

  margin-top: 40px;
  color: white;
  background: #54B0FB;
  border: 0;
  height: @minboxgao;
  line-height: @minboxgao;
  border-radius: @circlemin;
  width: 100%;
}

.select_container {
  width: 100%;
  height: @minboxgao;

  margin-top: @padingboxmax;
  line-height: @minboxgao;
}
.own_name{
  width: 202px;
height: 30px;
font-size: 30px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000000;
line-height: 30px;
padding: 12px 0;
margin: 12px 0;
}
</style>
